import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../pages/home.js'
import Notfound from '../pages/notfound.js'
import UserLogin from '../pages/userLogin.js'
import Account from '../pages/account.js'
import ProtectedRoute from '../config/protectedRoute.js'
import Unauthorized from '../pages/unauthorized.js'
import Settings from '../pages/settings.js'
import ResetPassword from '../pages/resetPassword.js'
import Notifications from '../pages/notifications.js'
import Dashboard from '../pages/dashboard.js'
import Reports from '../pages/reports.js'
import MaterialCreate from '../pages/createMaterial.js'
import Materials from '../pages/materials.js'
import MaterialDetails from '../pages/materialDetails.js'
import Suppliers from '../pages/suppliers.js'
import SupplierDetails from '../pages/supplierDetails.js'
import CreateSupplier from '../pages/createSupplier.js'
import Inventory from '../pages/inventory.js'
import Invoices from '../pages/invoices.js'
import StockIn from '../pages/stockIn.js'
import StockOut from '../pages/stockOut.js'
import PurchaseOrders from '../pages/purchaseOrders.js'
import CreatePurchaseOrder from '../pages/createPurchaseOrders.js'
import PurchaseOrderDetails from '../pages/purchaseOrderDetails.js'
import LoginOtpVerificationPage from '../pages/loginOtpVerificationPage.js'
import FinishedGoods from '../pages/finishedGoods.js'
import CreateTicket from '../pages/createTicket.js'
import TicketList from '../pages/tickets.js'
import ManageTicket from '../pages/manageTicket.js'
import LoginApprovalWait from '../pages/loginApprovalWait.js'
import MyTickets from '../pages/myTickets.js'
import AgentPerformanceList from '../pages/agentPerformanceList.js'

const RoutesPage = () => {
    return (
        <Routes>
            <Route path="/" element={<UserLogin />} />
            <Route path="/home" element={<Home />} />
            <Route path="*" element={<Notfound />} />
            
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/verify-otp" element={<LoginOtpVerificationPage />} />
            <Route path="/login-approval-wait" element={<LoginApprovalWait />} />




            
            <Route path="/settings" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Settings /></ProtectedRoute>}/>
            <Route path="/account" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Account /></ProtectedRoute>}/>



            <Route path="/materials" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Materials /></ProtectedRoute>}/>
            <Route path="/materials/create" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><MaterialCreate /></ProtectedRoute>}/>
            <Route path="/materials/:materialId" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><MaterialDetails /></ProtectedRoute>}/>


            <Route path="/materials/:materialId/stock-in" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}> <StockIn /> </ProtectedRoute>}/>
            <Route path="/materials/:materialId/stock-out" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}> <StockOut /> </ProtectedRoute>}/>

            <Route path="/suppliers" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Suppliers /></ProtectedRoute>}/>
            <Route path="/suppliers/:supplierObjId" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><SupplierDetails /></ProtectedRoute>}/>
            <Route path="/suppliers/create" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><CreateSupplier /></ProtectedRoute>}/>


            <Route path="/reports" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Reports /></ProtectedRoute>}/>
            <Route path="/inventory" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Inventory /></ProtectedRoute>}/>
            <Route path="/invoices" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Invoices /></ProtectedRoute>}/>
            <Route path="/purchase-orders" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><PurchaseOrders /></ProtectedRoute>}/>
            <Route path="/purchase-orders/create" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><CreatePurchaseOrder /></ProtectedRoute>}/>
            <Route path="/purchase-orders/:poObjId" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><PurchaseOrderDetails /></ProtectedRoute>}/>
           
           


            <Route path="/finished-goods" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><FinishedGoods /></ProtectedRoute>}/>






            <Route path="/reset-password" element={<ResetPassword />} />


            <Route path="/dashboard" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Dashboard /></ProtectedRoute>}/>
       
            <Route path="/dashboard" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Dashboard /></ProtectedRoute>}/>
            <Route path="/notifications" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><Notifications /></ProtectedRoute>}/>




            <Route path="/tickets" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><TicketList /></ProtectedRoute>}/>
            <Route path="/tickets/:ticketObjId" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><ManageTicket /></ProtectedRoute>}/>
            <Route path="/tickets/create" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><CreateTicket /></ProtectedRoute>}/>
            <Route path="/my-tickets" element={<ProtectedRoute resource="csp" actions={["read", "write", "update"]}><MyTickets /></ProtectedRoute>}/>
            <Route path="/agent-performance" element={<ProtectedRoute resource="team" actions={["read", "write", "update"]}><AgentPerformanceList /></ProtectedRoute>}/>
        </Routes>
    )
}

export default RoutesPage